import { FormEvent, PropsWithChildren } from 'react';
import { UseInertiaFormProps } from 'use-inertia-form';
import { FormProvider } from '@/Contexts';

type FormProps<TForm> = PropsWithChildren<{
    form: Omit<UseInertiaFormProps<TForm>, 'processing' | 'progress' | 'get' | 'post' | 'put' | 'patch' | 'delete' | 'transform' | 'cancel' | 'recentlySuccessful' | 'wasSuccessful'>;
    onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
    className?: string;
}>

export const Form = <TForm extends unknown = unknown>({ form, onSubmit, children, ...rest }: FormProps<TForm>) => {
    return (
        // @ts-ignore
        <FormProvider value={form}>
            <form onSubmit={onSubmit} {...rest}>
                {children}
            </form>
        </FormProvider>
    );
};
